import { LoaderProps } from './types';

import { Loading } from './styled';

export default function Loader({ mode }: LoaderProps): JSX.Element {
  return <Loading $mode={mode} />;
}
